import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-rfid-highways',
  templateUrl: './rfid-highways.component.html',
  styleUrls: ['./rfid-highways.component.scss']
})
export class RfidHighwaysComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
